import {
    CREATE_ORDER_FAIL,
    CREATE_ORDER_REQUEST,
    CREATE_ORDER_SUCCESS,
    LOAD_ORDERS_FAIL,
    LOAD_ORDERS_REQUEST,
    LOAD_ORDERS_SUCCESS,
    ORDER_DETAILS_FAIL,
    ORDER_DETAILS_REQUEST,
    ORDER_DETAILS_SUCCESS,
    CLEAR_ERRORS
} from "../constants/orderConstant"

const initialState = {
    orders: [],
    order:{},
    loading: false,
    totalAmount: 0
}

export const orderReducer = (state = initialState, action) => {

    switch (action.type) {
        case LOAD_ORDERS_REQUEST:
            
            return {
                ...state,
                loading: true,
            }
        
        case LOAD_ORDERS_SUCCESS:
        
            return {
                ...state,
                loading:false,
                orders: action.payload.orders,
                totalAmount:action.payload.totalAmount
            }

        case LOAD_ORDERS_FAIL:
    
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        
            case ORDER_DETAILS_REQUEST:
    
                return {
                    ...state,
                    loading: true,
                }
            
            case ORDER_DETAILS_SUCCESS:
            
                return {
                    ...state,
                    loading: false,
                    order: action.payload.order,
                }
    
            case ORDER_DETAILS_FAIL:
        
                return {
                    ...state,
                    loading: false,
                    error: action.payload
                }
            case CREATE_ORDER_REQUEST:

            return {
                ...state,
                loading: true,
            }
            
            case CREATE_ORDER_SUCCESS:
            
                return {
                    ...state,
                    loading: false,
                    order: action.payload.order,
                }
    
            case CREATE_ORDER_FAIL:
        
                return {
                    ...state,
                    loading: false,
                    error: action.payload
                }

        case CLEAR_ERRORS:
    
            return {
                ...state,
                error: null
            }
    
        default:
            return state
    }

}
